/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Params {
  supplierId: number;
  id: number;
}

export function deleteOneBaseMgmtSupplierOrderControllerSupplierOrder(http: HttpClient, rootUrl: string, params: DeleteOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteOneBaseMgmtSupplierOrderControllerSupplierOrder.PATH, 'delete');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteOneBaseMgmtSupplierOrderControllerSupplierOrder.PATH = '/api/mgmt/supplier/{supplierId}/orders/{id}';
